// =============================================
// src/pages/About.tsx
// =============================================
import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  useTheme,
} from '@mui/material';


const About: React.FC = () => {
    const theme = useTheme();
  return (
    <>

      <Box sx={{ bgcolor: theme.palette.customBackground , minHeight: '100vh', color: 'text.primary' }}>
        
        {/* Hero Section */}
        <Box
          sx={{
            height: { xs: '50vh', md: '60vh' },
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Container maxWidth="lg">
            <Typography variant="h1" sx={{ color: 'text.primary', mb: 2 }}>
              About Route Royale
            </Typography>
            <Typography variant="h4" sx={{ color: 'text.secondary', maxWidth: 700 }}>
              Redefining luxury transportation with elegance, reliability, and unmatched service.
            </Typography>
          </Container>
        </Box>

        <Container maxWidth="lg" sx={{ py: 10 }}>
          
          {/* Our Story */}
          <Typography variant="h3" sx={{ mb: 3, textAlign: 'center' , color: 'text.primary' }}>
            Our Story
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: '1.1rem',
              lineHeight: 1.8,
              maxWidth: 800,
              mx: 'auto',
              textAlign: 'center',
              color: 'text.secondary',
              mb: 8,
            }}
          >
            Founded with a passion for excellence, Route Royale was born from the belief that 
            transportation should be more than just getting from point A to point B. 
            It should be an experience — one defined by luxury, comfort, and impeccable service.
          </Typography>

          {/* Values / Why Us */}
          <Typography variant="h3" sx={{ mb: 5, textAlign: 'center' }}>
            What Sets Us Apart
          </Typography>

          <Grid container spacing={4}>
            {[
              {
                title: "Elite Fleet",
                desc: "Our fleet consists of meticulously maintained luxury vehicles, including the latest Cadillac Escalade models.",
              },
              {
                title: "Professional Chauffeurs",
                desc: "Every driver is hand-selected, background-checked, and trained to the highest standards of service.",
              },
              {
                title: "Punctuality & Reliability",
                desc: "We pride ourselves on being on time — every time. Your schedule is our priority.",
              },
              {
                title: "Personalized Experience",
                desc: "From airport transfers to special events, we tailor every journey to your exact needs.",
              },
            ].map((item, index) => (
              <Grid key={index} size={{ xs: 12, md: 6 }}>
                <Card
                  sx={{

                    bgcolor: 'rgba(30, 41, 59, 0.6)',
                    backdropFilter: 'blur(12px)',
                    height: '100%',
                    transition: 'all 0.3s',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      bgcolor: 'rgba(30, 41, 59, 0.95)',
                    }
                  }}
                  
                >
                  <CardContent sx={{ p: 5 }}>
                    <Typography variant="h5" sx={{ mb: 2, color: 'white' }}>
                      {item.title}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#cbd5e1' }}>
                      {item.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* Final CTA */}
        <Box sx={{ py: 8 }}>
          <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
            <Typography variant="h4" sx={{ mb: 3 }}>
              Ready to experience true luxury?
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{ px: 8, py: 2, fontSize: '1.1rem' }}
            >
              Book Your Ride Today
            </Button>
          </Container>
        </Box>

      </Box>

    </>
  );
};

export default About;